import {createContext} from 'react';
import {Page} from './constant/page';
import {DEFAULT_PAGE_CONTEXT} from './hook/transition/useTransitionManager';
import {ITheme} from './type';

export const PageAppContext = createContext<IPageAppContext>({
  page: Page.Home,
  prevPage: undefined,
  currentUrl: '',
  title: '',
  rid: '',
});
export interface IPageAppContext {
  page: Page;
  prevPage: Page | undefined;
  currentUrl: string;
  title: string;
  rid: string;
}

export const PageContext = createContext<IPageContext>(DEFAULT_PAGE_CONTEXT);

export interface IPageContext {
  title: string;
}

export const PageContainerContext = createContext<IPageContainerContext>({
  paddingTop: 0,
});

interface IPageContainerContext {
  paddingTop: number;
}

export const LiteVersionContext = createContext<boolean>(false);

export const HiddenBottomButtonContext = createContext<boolean>(false);

export const ThemeContext = createContext<IThemeContext>({
  theme: 'dark',
  setTheme: () => {},
});

interface IThemeContext {
  theme: ITheme;
  setTheme: (theme: ITheme) => void;
}
